import React, { Component } from "react";
import "./ViewReplace.styles.scss";

// import { Icon } from "react-materialize"
import fse_img from "../../_image/person.svg";
import leave_day_img from "../../_image/event.svg";
import BounceLoader from "react-spinners/BounceLoader";

import SpotRow from "./SpotRow/SpotRow";

import axios from "axios";
import AxiosClient from "../../../../../../../../Network/AxiosClient";
// import moment from "moment"

export default class ViewReplace extends Component {
  state = {
    assignments: [{ spot_code: "", mdos: [] }],
    showErr: false,
    loading: false,
    mdo_list: [],
    mdo_loading: false,
  };

  componentDidMount() {
    this.getData();
    const spot_codes = this.props.data.spot_codes;
    let arra = [];
    spot_codes.map((spot) => arra.push({ spot_code: spot, mdos: [] }));
    this.setState({ assignments: arra });
  }

  handleAssignments = (spot, mdos) => {
    let mdoArray = [];
    mdos.map((mdo) => mdoArray.push(mdo.id));

    let temp = this.state.assignments.map((objs) =>
      objs.spot_code === spot ? { spot_code: spot, mdos: mdoArray } : objs
    );

    this.setState({ assignments: temp });
  };

  handleFormSubmit = () => {
    let allAssigned = this.state.assignments.find((obj) => obj.mdos.length < 1);

    if (allAssigned === undefined) {
      this.setState({ showErr: false, loading: true });

      axios
        .post(
          `${process.env.REACT_APP_API_URL}/api/admin_panel/v1/${this.props.data.id}/mdo-replace`,
          this.state.assignments,
          {
            headers: {
              Authorization:
                "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
            },
          }
        )
        .then((res) => {
          this.props.handleSave();
          setTimeout(() => {
            this.setState({
              loading: false,
              showErr: false,
            });
            this.props.viewMainOnClick();
          }, 2000);
        })
        .catch((err) =>
          console.log(`something went wrong while replacing MDO:: ${err}`)
        );
    } else {
      this.setState({ showErr: true, loading: false });
    }
  };

  getData = () => {
    this.setState({ mdo_loading: true });
    AxiosClient.get(
      `${process.env.REACT_APP_API_URL}/api/admin_panel/v1/mdo-list?include=all`,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
        },
      }
    ).then((res) => {
      let filteredMdo = res.data.data.filter(
        (mdo) => mdo.id !== this.props.mdoid
      );
      this.setState({ mdo_list: filteredMdo, mdo_loading: false });
    });
  };

  render() {
    const {
      name,
      contact_number,
      employee_id,
      image,
      fse,
      leave_day,
      spot_codes,
      // status,
      id,
    } = this.props.data;

    return (
      <div>
        <div className="viewreplace-body">
          <div className="basic">
            <div className="image">
              <img
                src={
                  image
                    ? image
                    : "https://png.pngitem.com/pimgs/s/506-5067022_sweet-shap-profile-placeholder-hd-png-download.png"
                }
                alt="default"
              />
              <div className="tag">
                ID # {employee_id ? employee_id : "N/A"}
              </div>
            </div>

            <div className="description">
              <div className="name-container">
                <div className="name">{name}</div>
                <div className="type">MDO</div>
              </div>

              <div className="walet">{contact_number}</div>

              <div className="info-row">
                <div className="info-container">
                  <img src={fse_img} alt="fse" />
                  <div className="info">
                    <div className="tag">FSE</div>
                    <div className="value">{fse}</div>
                  </div>
                </div>

                <div className="info-container">
                  <img src={leave_day_img} alt="leave day" />
                  <div className="info">
                    <div className="tag">Leave Day</div>
                    <div className="value">
                      {leave_day.length > 0 ? (
                        leave_day[0]
                      ) : (
                        <span>Not Assigned</span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="replace-table">
          <div className="headers">
            <span>Spots</span>
            <span>Assign To</span>
          </div>
          {this.state.mdo_loading && (
            <div className="loading-mdo">Loading MDO and Spot Data</div>
          )}
          {spot_codes.map((spot) => (
            <SpotRow
              key={spot}
              data={spot}
              mdoid={id}
              mdoList={this.state.mdo_list}
              loading={this.state.mdo_loading}
              handleAssignments={this.handleAssignments}
            />
          ))}
        </div>

        <div className="footer-replace">
          <BounceLoader
            className="loader"
            color={"#e2136e"}
            size={20}
            loading={this.state.loading}
          />
          {this.state.showErr && (
            <div className="error-msg">
              <span>
                Please assign MDOs to <strong>all</strong> the spots
              </span>
            </div>
          )}
          <button
            className="button--cancel"
            onClick={this.props.viewMainOnClick}
          >
            {" "}
            Cancel
          </button>
          <button className="button--save" onClick={this.handleFormSubmit}>
            {" "}
            Confirm{" "}
          </button>
        </div>
      </div>
    );
  }
}
